/* eslint-disable */
export default {
  DOMAIN: 'https://secure.guestapp.id/',
  HOST_DOMAIN: 'secure.guestapp.id',
  TICKET_BASE_API_CORE : "https://api.marketconnect.id/guestapp-ticket/api/",
  RESTO_BASE_API_CORE : "https://api.marketconnect.id/guestapp-restaurant/api/",
  HOTEL_BASE_API_CORE : "https://api.marketconnect.id/guestapp-hotel/api/",
  CONCIERGE_BASE_API_CORE : "https://api.marketconnect.id/concierge/api/",
  AFFILIATE_BASE_API_CORE : "https://api.marketconnect.id/merchant-affiliate/api/",
  COMMUNITY_BASE_API : "https://api.marketconnect.id/guestapp-community/api/",
  BASE_API : "https://api.marketconnect.id/",
  BASE_APP_URL: "https://secure.guestapp.id/",
  JOKUL_URL: "https://jokul.doku.com/jokul-checkout-js/v1/jokul-checkout-1.0.0.js",
  MIDTRANS_URL: "https://app.midtrans.com/snap/snap.js",
  XENDIT_URL: "https://js.xendit.co/v1/xendit.min.js",
  XENDIT_NEW_URL: "https://js.xendit.co/v3/xendit.min.js",
  XENDIT_API_URL: "https://api.xendit.co/",
  IPAYMU_URL: "https://my.ipaymu.com/",
  ENV: 'prod',
  COMMUNITY_SYSTEM: 'f78b603c-47a0-479b-b55f-67a3ee7b264f',
  MERCHANT_CUSTOM: {
    balibirdpark: 'balibirdpark'
  }
}


// WEBPACK FOOTER //
// ./src/config/prod.js